// extracted by mini-css-extract-plugin
export default {"root":"QVXbsudx_Yeaxpd9AgGb","fullscreen":"boNw2170xAP0sCvgnCH0","fullPage":"VajQyzwE5ZZBxYKELwbI"};